import { AlertTriangle, LoaderCircle, RefreshCw, Wallet } from 'lucide-react';
import { useWallet } from '../state/WalletContext';

interface DataStateProps {
  mode: 'loading' | 'authenticated' | 'demo' | 'empty' | 'stale' | 'error';
  error: string | null;
  onRetry(): void;
  resource?: string;
}

export function MemberDataState({ mode, error, onRetry, resource = 'member data' }: DataStateProps) {
  const wallet = useWallet();

  if (mode === 'loading') {
    return (
      <section className="neutral-not-found" role="status">
        <LoaderCircle className="spin" />
        <h1>Loading finalized {resource}</h1>
        <p>The app is reading the indexed on-chain data through the authenticated API.</p>
      </section>
    );
  }

  const needsConnection = !wallet.address;
  const needsAuthentication = Boolean(wallet.address && !wallet.authenticated);
  return (
    <section className="neutral-not-found">
      <AlertTriangle />
      <h1>{error ? `Could not load ${resource}` : `No ${resource} available`}</h1>
      <p>{error ?? (needsConnection
        ? 'Connect a wallet to load its B-Dynamic IDs.'
        : needsAuthentication
          ? 'Sign the session challenge to load your indexed on-chain data.'
          : 'No B-Dynamic ID of this wallet has been indexed from the chain yet.')}</p>
      {needsConnection ? (
        <button className="button primary" type="button" onClick={() => void wallet.connect()}><Wallet size={15} /> Connect wallet</button>
      ) : needsAuthentication ? (
        <button className="button primary" type="button" onClick={() => void wallet.authenticate()}><Wallet size={15} /> Sign in securely</button>
      ) : (
        <button className="button secondary" type="button" onClick={onRetry}><RefreshCw size={15} /> Retry</button>
      )}
    </section>
  );
}
